<main>
    <div class="card" id="card-config">
        <div class="head">
          <h1>Permissões</h1> 
          <div class="linha">
            <span>lista de todas as suas permissões</span>
            <button class="btn-nav" routerLink="../permissoes/cadastro">
              <mat-icon class="material-icons-sharp">
                rule
                </mat-icon>
               Nova Permissão </button>
          </div> 
        </div>
        <div class="table-responsive">
        <table class="table">
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th scope="col">Nome</th>
                <th scope="col">Descrição</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              
              <tr *ngFor="let permissao of permissoes | 
              paginate: { currentPage: page, itemsPerPage: pageSize, totalItems: count}"
              >
                <td scope="row">{{permissao.sr_id}}</td>
                <td>{{permissao.vc_nome}}</td>
                <td>{{permissao.vc_descricao}}</td>
                <!-- <td> 
                    <button *ngIf="verificarPermissao(['atualizar_permissao'])" class="btn-nav" routerLink="../permissoes/atualizar/{{permissao.sr_id}}" routerLinkActive="router-link-active" > <mat-icon class="material-icons-sharp">
                      edit
                      </mat-icon>Editar</button>
                    <button  *ngIf="verificarPermissao(['status_permissao'])" class="btn-nav"> <mat-icon class="material-icons-sharp del">
                      delete_forever
                      </mat-icon>Excluir</button>
                </td> -->
              </tr>
            </tbody>
          </table>
          <div class="lista-vazia" *ngIf="!permissoes.length">
            <p>Não há permissões para listar.</p>
          </div>          
        </div>
      </div>
        <pagination-controls class="pagination" (pageChange)="mudarPagina($event)" previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
</main>